export enum AutoUpdaterMergeStrategy {
    /** If there are conflicting field changes, use the remote changes */
    RemoteOverwritesLocal,

    /** If there are conflicting field changes, use the local changes */
    LocalOverwritesRemote,
}
